import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';

import { GlobalSearchInputSize, SizeScheme } from './GlobalSearchInput.types';

const sizeScheme: (tokens: Theme['tokens'], px: Theme['px']) => SizeScheme = (
  tokens,
) => ({
  [GlobalSearchInputSize.large]: {
    fontSize: tokens.typography.variant.body2.fontSize,
    lineHeight: 1,
    height: '24px',
    paddingBlock: tokens.spacing['16'],
  },
  [GlobalSearchInputSize.medium]: {
    fontSize: tokens.typography.variant.body2.fontSize,
    lineHeight: 1,
    height: '24px',
    paddingBlock: tokens.spacing['8'],
  },
});

export const useStyles = makeStyles<{
  size: GlobalSearchInputSize;
}>()(({ tokens, px }, { size }) => ({
  globalSearchInputFrom: {
    width: '100%',
    position: 'relative',
  },
  globalSearchInputRoot: {
    borderRadius: tokens.radius.m,
    background: tokens.colors.bg.light.primary,
    border: `1px solid ${tokens.colors.stroke.primary}`,
    '&.MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderWidth: `${tokens.border.s}px`,
      },
    },
  },
  globalSearchInput: {
    ...sizeScheme(tokens, px)[size],
    paddingLeft: tokens.spacing['32'],
    paddingRight: tokens.spacing['32'],
  },
  notchedOutline: {
    borderWidth: 0,
  },
  button: {
    '&&': {
      position: 'absolute',
      top: 0,
      right: 0,
      width: `${px(35)}px !important`,
      height: `${px(35)}px !important`,
    },
  },
  helperText: {
    marginLeft: 0,
    marginRight: 0,
  },
}));
